//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalProjects = ({ count }: { count: number }) => {
  return <StatCard title='Total Projects' stat={count} />;
};

export default TotalProjects;
